import React from "react";
import { Modal }  from "react-bootstrap";

export default class AskToUseChrome extends React.Component {
  render () {
    const { show, onHide, reasonToUseChrome } = this.props;
    return (
      <Modal show={show}>
        <Modal.Body>
          {this._showReason(reasonToUseChrome)}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button className="btn btn-primary" onClick={onHide}>
              ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }

  _showReason = (reasonToUseChrome) => {
    if (reasonToUseChrome === "webRTCNotSupported") {
      return <h4>Please use Chrome. Your current browser would not work for the session.</h4>;
    }
    else if (reasonToUseChrome === "videoSizeNotSupported") {
      return (<h4>Please use Chrome for better video quality. If you don't have Chrome, then continue.</h4>);
    }
    else if (reasonToUseChrome === "notUsingChromeOrFirefox") {
      return (<h4>Please use Chrome to join the session.</h4>);
    }
    return (<h4>Please Use Chrome</h4>);
  }
}